import type { FC } from 'react';

import CheckboxBasic from '../../../checkbox_basic/checkbox_basic';
import {
  type FieldWrapperProps,
  FormContextConsumer,
} from '../../form_context/form_context';
import formField, { pickProps } from '../../form_field/form_field';

const componentProps = ['size', 'uiKey'] as const;

const Field = formField(CheckboxBasic, {
  defaultValue: null,
  transformProps: (props) => pickProps(props, componentProps),
});

type CheckboxBasicFieldWrapperProps = FieldWrapperProps<typeof Field>;

const CheckboxBasicFieldWrapper: FC<CheckboxBasicFieldWrapperProps> = (
  props,
) => (
  <FormContextConsumer>
    {(context) => <Field {...props} {...context} />}
  </FormContextConsumer>
);

export default CheckboxBasicFieldWrapper;
